<template>
  <div class="edrea_tm_modalbox" :class="open ? 'opened' : ''">
    <div class="box_inner">
      <div class="close">
        <a href="#" @click="close"><i class="icon-cancel"></i></a>
      </div>
      <div class="description_wrap">
        <div class="about_popup_details">
          <div class="left">
            <div class="left_inner">
              <div class="author">
                <div class="avatar_image">
                  <img src="img/thumbs/1-1.jpg" alt="" />
                  <div class="main" data-img-url="img/about/1.png"></div>
                </div>
                <div class="short">
                  <h3 class="name">
                    {{ aboutData.firstName }}
                    <span class="coloring">{{ aboutData.lastName }}</span>
                  </h3>
                  <h3 class="job">
                    <AnimationText />
                  </h3>
                </div>
              </div>
              <div class="list">
                <ul>
                  <li>
                    <div class="list_inner">
                      <i class="icon-mail-1"></i>
                      <span>
                        <a :href="`mailto:${aboutData.email}`">{{ aboutData.email }}</a>
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="right_inner">

   <div class="service">
  <div class="about_title">
    <h3>
      <span>Quem <span class="coloring">Somos</span></span>
    </h3>
  </div>
  <div class="text" >
    <p>
      Histórico comprovado de <span>7+ dígitos em Lead Generation.</span> Operamos nos mercados mais competitivos do digital e sabemos exatamente o que é necessário para escalar.
    </p>
    <p style="margin-top: 10px;">
      Não prometemos. Entregamos. Enquanto a maioria compete, nós dominamos.
    </p>
  </div>
</div>
              <div class="service" style="margin-top: 30px;">
                <div class="about_title">
                  <h3>
                    <span>Nossa <span class="coloring">Expertise</span></span>
                  </h3>
                </div>
                <div class="list">
                  <ul class="two-col">
                    <li v-for="(service, i) in aboutData.serviceLists" :key="i">
                      <i class="icon-right-dir"></i>{{ service }}
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import AnimationText from "../AnimationText.vue";
export default {
  name: `AboutPopup`,
  components: { Swiper, SwiperSlide, AnimationText },
  data() {
    return {
      open: false,
      aboutData: {
        firstName: "Oriqy",
        lastName: "Agency",
        email: "contato@oriqy.com",
        serviceLists: [          
          "Social Media Marketing",       
          "Digital Products",          
          "Brand Scaling",          
          "Media Buying",          
          "E-commerce",      
          "iGaming",  
          "SEO",          
          "OFM",          
        ],
        skills: {
          programming: [
            { name: "WordPress", value: "100" },
            { name: "JavaScript", value: "100" },
            { name: "Python", value: "100" },
          ],
        },
      },
    };
  },
  methods: {
    close() {
      this.open = false;
    },
  },
  mounted() {
    const aboutPopup = document.getElementById("aboutPopup");
    aboutPopup.addEventListener("click", () => {
      this.open = true;
    });
  },
  setup() {
    return {
      modules: [Navigation, Pagination],
    };
  },
};
</script>

<style scoped>
.two-col {
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
}

.two-col li {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.two-col li i {
  flex-shrink: 0;
  margin-top: 3px;
}
</style>